module.exports = __webpack_public_path__ + "img/auth_success.ad5dc8ae.png";